import * as React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

const CallToAction = () => {
  return (
    <section className="py-16">
      <div className="container px-4 md:px-6">
        <div className="bg-gradient-to-r bg-background/30 rounded-3xl overflow-hidden shadow-xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="p-8 md:p-12 lg:p-16">
              <h2 className="text-3xl md:text-4xl text-primary font-bold  mb-4">
                Ready to find the right therapist?
              </h2>
              <p className="text-lg  mb-8 max-w-md">
                Take our mental health assessment and get matched with a therapist who understands your unique needs.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="/screening/screening_tool_response/new">
                  <Button variant="secondary" className="rounded-full px-8 py-6 h-auto text-lg">
                    Take the Assessment
                  </Button>
                </a>
                <a href="/intake_request_without_quiz/new">
                  <Button variant="outline" className="rounded-full px-8 py-6 h-auto text-lg">
                    Match Me With A Therapist
                  </Button>
                </a>
              </div>
            </div>
            <div className="hidden md:block relative h-full min-h-[300px]">
              <img
                alt="Therapist"
                src="https://res.cloudinary.com/dm9jepekh/image/upload/v1745980624/40328_duu4n8.jpg"
                className="absolute inset-0 h-full w-full object-cover opacity-80"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
